// file-upload.fake.service.js

import * as axios from "axios";

const BASE_URL = 'https://jcjjde6dh8.execute-api.us-east-1.amazonaws.com/Prod/sign-s3';

function upload(formData) {
    const photos = formData.getAll('photos');
    const promises = photos.map((x) => getImage(x)
        .then(data => ({
            originalName: x.name,
            fileName: x.name,
            awsData: data
        })));
    return Promise.all(promises);
}

function getImage(file) {
    return new Promise((resolve, reject) => {
        const fReader = new FileReader();
        const img = document.createElement('img');

        fReader.onload = () => {
            img.src = fReader.result;
            resolve(signedRequest(file));
        }

        fReader.readAsDataURL(file);
    })
}

function getBase64Image(img) {
    const canvas = document.createElement('canvas');
    canvas.width = img.width;
    canvas.height = img.height;

    const ctx = canvas.getContext('2d');
    ctx.drawImage(img, 0, 0);

    const dataURL = canvas.toDataURL('image/png');

    return dataURL;
}

function signedRequest(file) {
    console.log(file)
    return new Promise((resolve, reject) => {
        const url = `${BASE_URL}?file_name=${file.name}&file_type=${file.type}`;
        axios.get(url)
            .then(response => {
                resolve (uploadFile(response, file))
            }).catch(error => {
                reject('error', error)
        })
    });
}


function uploadFile(response, file){
    return axios.put(response.data.signedRequest, file, { headers: { 'Content-Type': file.type, 'x-amz-acl': 'public-read' } }).then(rs => {
        return rs
    }).catch(err => {
        console.error(err)
    })
}

export { upload }
